import { Fragment, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import MyCropper from "../../tools/MyCropper";
import { setPreload } from "../../../server/CartsOpen";
import { updateProductFields } from "../../../server/Product";
import { showAlertWithConfirmCancel } from "../../../server/ShowAlert";
import { newS3BucketUrl } from "../../../../axiosInstance";

const ProductEditImg = () => {
  const { product, stationId } = useSelector((state) => ({
    product: state.selectedProduct.product,
    stationId: state.user.stationId,
  }));

  const [imagesList, setImagesList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (product?.media?.length) {
      setImagesList(product.media);
    } else {
      setImagesList([]);
    }
  }, [product]);

  const validImages = useMemo(
    () => imagesList.filter((img) => img?.path),
    [imagesList],
  );

  const mainImage =
    validImages.find((img) => img.default) ||
    validImages[validImages.length - 1];

  const getImageUrl = (img) => {
    if (!img?.path) return "";
    if (img.path.startsWith("data:")) return img.path;

    const cleanPath = img.path.startsWith("/")
      ? img.path.substring(1)
      : img.path;

    return `${newS3BucketUrl}/${encodeURIComponent(cleanPath)}`;
  };

  const deleteImage = (index) => {
    showAlertWithConfirmCancel({
      msgTitle: "האם אתה בטוח שברצונך למחוק את התמונה?",
      confirmText: "מחק",
      cancelText: "ביטול",
      onConfirm: async () => {
        dispatch(setPreload(true));

        const newMedia = [
          ...validImages.slice(0, index),
          ...validImages.slice(index + 1),
        ];

        try {
          await updateProductFields(stationId, product.productId, {
            media: newMedia,
          });
          setImagesList(newMedia);
        } finally {
          dispatch(setPreload(false));
        }
      },
    });
  };

  const uploadImg = (data) => {
    if (!data?.media?.length) return;

    const newImages = data.media
      .filter((img) => img?.path)
      .map((img) => ({
        path: img.path,
        size: img.size || 0,
        default: img.default || false,
      }));

    if (!newImages.length) return;

    setImagesList((prev) => [...prev, ...newImages]);
    dispatch(setPreload(false));
  };

  if (!product) return null;

  return (
    <Fragment>
      <div className="flex" style={{ marginBottom: "20px" }}>
        <MyCropper
          uploadImg={uploadImg}
          itemId={product.productId}
          beforeFileName={`${product.mkt}_${product.gtin}_`}
        />
      </div>

      {mainImage && (
        <div className="main-img-wrapper" style={{ margin: "20px 0" }}>
          <img
            src={getImageUrl(mainImage)}
            alt="תמונה ראשית"
            style={{
              width: "300px",
              height: "300px",
              objectFit: "cover",
              borderRadius: "8px",
              border: "1px solid #ccc",
            }}
          />
        </div>
      )}

      {/* רשימת תמונות */}
      {validImages.length ? (
        <div
          className="img-list"
          style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
        >
          {validImages.map((img, index) => (
            <div
              key={`${img.path}-${index}`}
              style={{
                position: "relative",
                width: "100px",
                height: "100px",
                borderRadius: "5px",
                overflow: "hidden",
                border: "1px solid #ddd",
              }}
            >
              <img
                src={getImageUrl(img)}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <img
                src={`${newS3BucketUrl}/imagesbucketv1/deleteIcon.svg`}
                alt="מחק"
                onClick={() => deleteImage(index)}
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  width: "20px",
                  height: "20px",
                  cursor: "pointer",
                  background: "rgba(255,255,255,0.7)",
                  borderRadius: "50%",
                  padding: "2px",
                }}
              />
            </div>
          ))}
        </div>
      ) : (
        <div style={{ color: "#777", marginTop: "10px" }}>אין תמונות להצגה</div>
      )}
    </Fragment>
  );
};

export default ProductEditImg;
